<template>
  <div>
    <div v-if="subscriptionDetails.ratePlans.length > 1" class="bundlesCancelSubscription">
      <h3>{{ $t('subscription_return.accordion.cancelAndReturn.bundlesCancelSubscription.text', 'Changed your mind?') }}</h3>
      <div class="withdrawBundles">
        <app-checkbox
          v-for="(item, index) in enableWithdrawBundles"
          :key="index"
          :id="item.id"
          :label="item.text"
          @input="item.checked = $event"
          :value="item.checked"
        />
      </div>
      <app-button
        type="submit"
        @click.prevent="withdrawReturnTask.run();"
        :is-loading="withdrawReturnTask.isActive"
        :disabled="!withdrawSelected"
        data-name="SubscriptionCancel-submitButton"
      >
        {{ $t('subscription_return.confirmation.cancelReturn.button', 'Continue subscription') }}
      </app-button>
    </div>
    <template v-else>
      <p>
        {{ $t('subscription_return.confirmation.returnRequestDate.label', 'Cancellation request date') }}
        <!--  tryBuyCanDoReturn/replenshipmentCanDoReturn.returnCreatedDate -->
        <span> {{ (deviceReturnInfos && deviceReturnInfos.returnCreatedDate || replenshipmentReturnInfos && replenshipmentReturnInfos.returnCreatedDate) | formatLocalDate }} </span>
      </p>

      <p>
        {{ $t('subscription_return.confirmation.status.label', 'Status') }}
        <!-- subscriptionDetails.returnStatus -> tryBuyCanDoReturn/replenshipmentCanDoReturn-->
        <span v-if="deviceReturnInfos"> {{ $t(`subscription_return.confirmation.status.${deviceReturnInfos.returnStatus.replace(/\s/gi, '-')}`, `${deviceReturnInfos.returnStatus}`) }}</span>
        <span v-if="replenshipmentReturnInfos"> {{ $t(`subscription_return.confirmation.status.${replenshipmentReturnInfos.returnStatus.replace(/\s/gi, '-')}`, `${replenshipmentReturnInfos.returnStatus}`) }}</span>
      </p>

      <!-- tryBuyCanDoReturn/replenshipmentCanDoReturn -> subscriptionDetails-->
      <template v-if="deviceReturnInfos && deviceReturnInfos.returningWithdrawable || replenshipmentReturnInfos && replenshipmentReturnInfos.returningWithdrawable">
        <p class="cancel-description">
          {{ $t('subscription_return.confirmation.cancelReturn.description', "We're sorry to see you go. Your cancellation is only processed when we receive the product. Changed your mind? No problem, just keep the device and choose to resume your subscription below.") }}
        </p>

        <app-button
          type="submit"
          @click.prevent="withdrawReturnTask.run();"
          :is-loading="withdrawReturnTask.isActive"
          data-name="SubscriptionCancel-submitButton"
        >
          {{ $t('subscription_return.confirmation.cancelReturn.button', 'Continue subscription') }}
        </app-button>
      </template>
    </template>
    <app-modal name="returnCancelled" class="returnCancelled">
      <div class="v--modal-content">
        <h3 class="modal-title">
        </h3>
        <div class="modal-content">
          <p>
            {{ $t('subscription_return.confirmation.cancelReturn.popup.content', 'All done. Your subscription will continue as normal.') }}
          </p>
        </div>
      </div>
    </app-modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Vue from 'vue'
  import ReturnCommonMixin from 'mixins/return-general'
  import { extractErrorMessage } from '@/utilities/common'

  export default {
    name: 'returning-withdraw',

    mixins: [ReturnCommonMixin],

    computed: {
      ...mapState('subscription', ['subscriptionDetails'])
    },

    tasks (t) {
      return {
        withdrawReturnTask: t(async function () {
          this.trackConversion({ name: 'interaction', description: 'button:stay_subscribed' })
          await Vue.api.subscription.returningWithdraw(this.subscriptionDetails.number, this.withdrawSelected)
          this.$bus.$emit('open-modal', 'returnCancelled')
          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
          this.$bus.$emit('close-withdraw-pop')
          window.location.reload()
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }).flow('restart')
      }
    },

    created () {
      this.enableWithdrawBundles = this.doWithdrawBundles()
    }
  }
</script>

<style lang="scss">
  .withdrawBundles {
    margin-top: .2rem;

    .AppCheckbox {
      &_label {
        display: flex;
        align-items: center;
        justify-content: center;
        height: .24rem;
        width: .24rem;
        background: transparent;
        border: .01rem solid #c4c4c4;
        border-radius: 50%;

        .Form_label {
          padding-left: 0;
        }
      }

      .Form_label {
        padding-left: 0 !important;
      }
    }

    .Form_group {
      margin-bottom: .16rem;

      .Form_label {
        font-size: .16rem;
        line-height: .22rem;
        margin: .01rem 0;
        color: #454545;
        letter-spacing: -.0001rem;
      }
    }
  }
</style>
